export default "__VITE_ASSET__DeiscwCF__"